<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
</style>
<style>
  /* required class */
  .my-editor {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #2d2d2d;
    color: #ccc;

    /* you must provide font-family font-size line-height. Example: */
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    height: 300px;
    line-height: 1.5;
    padding: 5px;
  }

  /* optional class for removing the outline */
  .prism-editor__textarea:focus {
    outline: none;
  }
</style>
<template>
  <div class="create-user-component">
    <vx-card class="grid-view-item mb-base overflow-hidden">
      <vx-tooltip :text="$t('Labels.Edit')" class="float-right" color="primary" >
        <vs-button  @click="edit(uuid)" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-edit" icon-pack="feather" type="filled"></vs-button>
      </vx-tooltip>
      <vx-tooltip :text="$t('Labels.Delete')" class="float-right" color="primary" >
        <vs-button  @click="requestPassword()" class="watersonic edit-button mr-2 mt-2" color="primary" icon="icon-trash" icon-pack="feather" type="filled"></vs-button>
      </vx-tooltip>
      <h4>{{$t('Labels.Detail')}}</h4>
      <table cellspancing="5" class="border-separate mt-5" v-if="response">
        <tbody>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Name')}}</td>
            <td class=" px-2 py-1">{{response.name}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Organization')}}</td>
            <td class=" px-2 py-1">{{response.organization_id}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Network')}}</td>
            <td class=" px-2 py-1">{{response.network_server_id}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.MacVersion')}}</td>
            <td class=" px-2 py-1">{{response.mac_version}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Region')}}</td>
            <td class=" px-2 py-1">{{response.reg_params_revision}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Timeout')}}</td>
            <td class=" px-2 py-1">{{response.uplink_interval}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.SupportClassB')}}</td>
            <td class=" px-2 py-1">{{response.supports_class_b}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Timeout')}}</td>
            <td class=" px-2 py-1">{{response.class_b_timeout}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.SupportClassC')}}</td>
            <td class=" px-2 py-1">{{response.supports_class_c}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Timeout')}}</td>
            <td class=" px-2 py-1">{{response.class_c_timeout}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Codec')}}</td>
            <td class=" px-2 py-1">{{response.payload_codec}}</td>
          </tr>
        
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.CreatedAt')}}</td>
            <td class=" px-2 py-1">{{response.created_at}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
            <td class=" px-2 py-1">{{response.user_creator.first_name + ' ' + response.user_creator.last_name}}</td>
          </tr>
          <tr>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.UpdatedAt')}}</td>
            <td class=" px-2 py-1">{{response.updated_at}}</td>
            <td class="bg-grey-light px-4 py-1 rounded ">{{$t('Labels.Creator')}}</td>
            <td class=" px-2 py-1">{{response.user_update != null ? response.user_update.first_name + ' ' + response.user_update.last_name:''}}</td>
          </tr>
        </tbody>
      </table>
    </vx-card>
    <div class="w-full">
      <vx-card class="grid-view-item mb-base overflow-hidden">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <label>{{$t('Labels.EncoderScript')}}</label>
            <prism-editor class="my-editor" v-model="response.payload_encoder_script" :highlight="highlighter" line-numbers readonly></prism-editor>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label>{{$t('Labels.DecoderScript')}}</label>
            <prism-editor class="my-editor" v-model="response.payload_decoder_script" :highlight="highlighter" line-numbers readonly></prism-editor>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="w-full">
        <vx-card class="grid-view-item mb-base overflow-hidden address-card">
            <div style="width: 100%">
                <select class="vs-vs-inputx vs-input--input mb-3" v-model="logLimit" style="float: right; width: 90px;" @change="getResponse()">
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            <h4>{{$t('ChangeHistory')}}</h4>
            <vs-table v-if="logData" :data="logData">
              <template slot="thead">
                <vs-th sort-key="updatedAt">
                  {{$t('Labels.UpdatedAt')}}
                </vs-th>
                <vs-th sort-key="name">
                  {{$t('Labels.Name')}}
                </vs-th>
                <vs-th sort-key="organization">
                  {{$t('Labels.Organization')}}
                </vs-th>
                <vs-th sort-key="id_nw">
                  {{$t('Labels.Network')}}
                </vs-th>
              </template>

              <template  slot-scope="{data}">
                <vs-tr :data="item" :key="index" v-for="(item, index) in data" >
                  <vs-td :data="item.updatedAt">
                    {{item.updatedAt}}
                  </vs-td>
                  <vs-td :data="item.name">
                    {{item.name}}
                  </vs-td>
                  <vs-td :data="item.organization_id">
                    {{item.organization_id}}
                  </vs-td>
                  <vs-td :data="item.id_nw">
                    {{item.id_nw}}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
        </vx-card>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import listItem from '@/components/listItem/listItem.vue'
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPass, globalPassActions} from '@/globalPass'
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css'
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/themes/prism-tomorrow.css'


export default {
  components: {
    listItem,
    PrismEditor
  },
  data () {
    return {
      response:{},
      uuid:this.$route.params.uuid, 
      logLimit: 5,
      logData: []
    }
  },

  methods: {
    async getData () {
      const params = {
        url: `device_profiles/${this.uuid}`,
        method: 'GET',
        params: {
          limit: this.logLimit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        if (this.response.device_profiles_records != null) this.logData = this.response.device_profiles_records
      })
    },

    edit (uuid) {
      window.location.href = `/profiles/${  this.uuid  }/update`
    },
    requestPassword () {
      globalPassActions.show()
    },
    async doDelete () {
      const params = {
        url: `device_profiles/${this.uuid}`,
        method: 'DELETE',
        params: {}
      }
      await request(params).then(response => {
      })       
    },
    goDevices () {
      window.location.href = `/devices?profile=${this.uuid}`
    },
    highlighter (code) {
      return highlight(code, languages.js)
    }
  },
  mounted () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.Profiles')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.Detail')
    this.$route.meta.pageTitle = this.$t('Path.Detail')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getData()
  },
  computed: {
    isVisiblePassword () {
      return globalPass.active
    } 
  },
  watch:{
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible == false) this.doDelete()
    }
  }
}
</script>
